import { ApplyFacilitiesFormSchema } from 'modals/CustomFieldModal/CustomFieldModal.types';
import { UseFormBehaviors_ValidationFnType } from 'hooks/useFormBehaviors/useFormBehaviors.types';

export const VALIDATION_communityIds: UseFormBehaviors_ValidationFnType<ApplyFacilitiesFormSchema> =
  (value): string => {
    const communityIds = value as string[];
    if (communityIds.length === 0) return 'Must select at least one communityId';
    return '';
  };
